
import * as requestCodeFormStyles from './RequestCodeForm.styles';

import FormikWrapper from '../../../FormikWrapper';
import RequestCode from '../RequestCode';
import { AccountField } from '../../../../utils/forms';
import {
  AuthStateContext,
  AuthStepAction,
  initialAuthContext,
} from '../../../../utils/authFormState';

import { mobileSchema } from '../../../SignUpForm/utils/form';
import { requestCodePerform } from '../../../../store/session/actions';

import { useDispatch } from 'react-redux';
import { useContext } from 'react';
import { parseMobileNumber } from 'foundshared/src/utils';
import { Form } from 'formik';
import * as yup from 'yup';
import * as R from 'ramda';
import type { FormTextFieldProps } from '../../../FormTextField/FormTextField';
import type {
  AuthContextFields} from '../../../../utils/authFormState';
import type { ReactElement} from 'react';

const validationSchema = yup.object().shape({
  [AccountField.MOBILE]: mobileSchema,
});

interface RequestCodeFormProps {
  requestCodeButtonText?: string;
  /**
   * If this component is used as part of a sign-up (inside a <form />) or as sign-in (login form).
   */
  embed?: boolean;
  mobileTextFieldProps?: Partial<FormTextFieldProps>;
}

/**
 * Step to input mobile number to recive verification code
 *
 * @param RequestCodeFormProps - Options to modify the form props
 * @returns Phone text field and button.
 */
function RequestCodeForm({ embed, ...props }: RequestCodeFormProps): ReactElement {
  const { classes: wrapperClasses } = requestCodeFormStyles.useWrapper();

  const { send, current } = useContext(AuthStateContext);

  const dispatch = useDispatch();

  const initialValues = R.pathOr(initialAuthContext.data, ['context', 'data'], current);

  const mobileConfirmed = (mobile: string) => {
    send(AuthStepAction.SUBMIT, {
      data: { mobile },
    });
  };

  // On submit parse the number, dispatch the request code action to redux, wait for a response, then update the xstate context
  const handleOnSubmit = (values: AuthContextFields) => {
    const mobileNumber = parseMobileNumber(values[AccountField.MOBILE] || '');
    const callback = () => mobileConfirmed(mobileNumber);

    if (mobileNumber) {
      dispatch(requestCodePerform(mobileNumber, { callback }));
    }
  };

  return (
    <div className={wrapperClasses.root}>
      {embed ? (
        <RequestCode embed={embed} handleOnSubmit={handleOnSubmit} {...props} />
      ) : (
        <FormikWrapper
          initialValues={initialValues}
          validateOnChange
          validateOnBlur={false}
          validateOnMount
          validationSchema={validationSchema}
          onSubmit={handleOnSubmit}
        >
          <Form>
            <RequestCode {...props} />
          </Form>
        </FormikWrapper>
      )}
    </div>
  );
}

export default RequestCodeForm;
